var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99966 1.33301C11.6816 1.33301 14.6664 4.31779 14.6664 7.99966C14.6664 11.6816 11.6816 14.6664 7.99966 14.6664C4.31779 14.6664 1.33301 11.6816 1.33301 7.99966C1.33301 4.31779 4.31779 1.33301 7.99966 1.33301ZM7.99966 1.99966C4.68598 1.99966 1.99966 4.68598 1.99966 7.99966C1.99966 11.3134 4.68598 13.9997 7.99966 13.9997C11.3134 13.9997 13.9997 11.3134 13.9997 7.99966C13.9997 4.68598 11.3134 1.99966 7.99966 1.99966ZM10.5315 4.52541L11.4743 5.46823L8.94285 7.99966L11.4743 10.5311L10.5315 11.4739L8.00004 8.94245L5.47332 11.4692L4.53051 10.5264L7.05723 7.99966L4.53051 5.47295L5.47332 4.53013L8.00004 7.05685L10.5315 4.52541Z",
    fill: "#FE5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.df57e843b92a1f23ddbe8b4737071878.svg";
export { ForwardRef as ReactComponent };